import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import {color, radius, type} from "common/tokens";
import ThemeIcon from "./ThemeIcon";

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
  },
  iconCircle: {
    width: 40,
    height: 40,
    borderRadius: radius.PILL,
    background: color.SECTION_ICON_BG,
    border: `1px solid ${color.SECTION_ICON_BORDER}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: color.SECTION_TITLE,
  },
  title: {
    ...type.sectionTitle,
    margin: 0,
    flex: '1 0 0',
    minWidth: 0,
    wordBreak: 'break-word',
  },
});

const SectionHeader = ({title, banner}) => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <span className={classes.iconCircle}>
        <ThemeIcon banner={banner} size={20}/>
      </span>
      <h2 className={classes.title}>{title}</h2>
    </div>
  );
};

export default SectionHeader;
